module.exports = __webpack_public_path__ + "static/Montaz_wspornikow_dla_blachodachowek-86b372b2a313d2e936ba070867e064b8.pdf";